import {clearStorageForInactiveSessionWrapper} from './clear-inactive-session-storage';
import {checkSSOSessionWrapper} from './check-sso-session';
import { datadogRum } from '@datadog/browser-rum';
import type { AuthObject } from '@white-label-types/auth';
import type { Context } from '@white-label-types/global-context';

export const handleRedirectCallback = async (
  app: Context['app'],
  authInstance: AuthObject
  ) => {
  // OAuth 2.0 Authorisation Code Flow: 'state' prevents CSRF attacks, auth 'code' is exchanged for tokens
  const searchParams = new URLSearchParams(globalThis.location.search);
  const state = searchParams.has('state');
  const code = searchParams.has('code');

  try {
    if (code && state) {
      await authInstance.auth0Client?.handleRedirectCallback();
      globalThis.location.href = '/';
    }
  } catch (error) {
    const errorContext = {
      file: 'white-label-plugin > auth.ts > initAuth()',
      urlParamCode: code,
      urlParamState: state,
    };
    datadogRum.addError(
      new Error('Error during initAuth:', { cause: error }),
      errorContext
    );
  } finally {
    await authInstance.refreshUser();
    clearStorageForInactiveSessionWrapper(app, authInstance);
    await checkSSOSessionWrapper(app, authInstance);
  }
};
